import { Controller } from "@hotwired/stimulus"
import { postGuide } from "../guides/persist"

// The desktop tour's screens (controllers/guide_controller.js).
const COMPUTER = "(min-width: 992px)"
const WAITING = "lc-checklist-card--after-tour"

// The onboarding checklist's card on the dashboard (dashboard/_onboarding_checklist). The server renders it whole;
// this records the steps it shows as newly done, so the corner on the next page does not announce them again, and
// saves hiding it (× before every step is done, "Skryť" after).
// While the product tour is still ahead the server marks the card and CSS hides it on a computer, where it would push
// the tour's dashboard steps down the page; it comes out when the tour says it is over (guides/runner.js). It records
// only what the user can see.
// See docs/superpowers/specs/2026-10-17-onboarding-checklist-design.md.
export default class extends Controller {
  static values = {
    first: Boolean,
    openUrl: String,
    stepUrl: String,
    dismissUrl: String,
    completeUrl: String,
    unseen: Array,
    afterTour: Boolean
  }

  tourFinished = () => {
    this.element.classList.remove(WAITING)
    this.afterTourValue = false
    this.stopWaiting()
    this.record()
  }

  connect() {
    if (this.afterTourValue && window.matchMedia(COMPUTER).matches) {
      document.addEventListener("guide:finished", this.tourFinished)
      this.waiting = true
      return
    }
    this.record()
  }

  disconnect() {
    this.stopWaiting()
  }

  dismiss() {
    postGuide(this.dismissUrlValue)
    this.element.remove()
  }

  complete() {
    postGuide(this.completeUrlValue)
    this.element.remove()
  }

  record() {
    // The list's first appearance writes its row, so the next step done is announced as new.
    if (this.firstValue) postGuide(this.openUrlValue)
    for (const id of this.unseenValue) postGuide(this.stepUrlValue, { step_id: id })
    // A page restored from Turbo's cache must not record them again.
    this.firstValue = false
    this.unseenValue = []
  }

  stopWaiting() {
    if (!this.waiting) return

    document.removeEventListener("guide:finished", this.tourFinished)
    this.waiting = false
  }
}
